import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { sahuaritaConfig } from "./data";

export default function SahuaritaPage() {
  return <CityPageTemplate config={sahuaritaConfig} />;
}